export {default as path} from "./src/path";



//////////////////
// WEBPACK FOOTER
// ./packages/element/node_modules/d3-path/index.js
// module id = 3
// module chunks = 0